import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';

import Typography from '@mui/material/Typography';
import { withStyles } from '@mui/styles';

import CustomIcon from '../../utils/CustomIcon';

const styles = theme => ({
  root: {
    alignItems: 'flex-start',
    background: theme.box.background,
    borderRadius: theme.box.borderRadius,
    padding: '12px',
    marginBottom: 24,
    display: 'flex',
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
  },
  iconContainer: {
    lineHeight: 0,
    width: 'auto',
  },
  icon: {
    marginRight: '12px',
  },
});

function Info({ classes, className, children }) {
  return (
    <div className={clsx(classes.root, className)}>
      <Typography variant="body1" display="inline" className={classes.iconContainer}>
        <CustomIcon className={classes.icon} icon="info" />
      </Typography>

      <div className={classes.container}>{children}</div>
    </div>
  );
}
Info.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.object,
  className: PropTypes.string,
};

Info.defaultProps = {
  children: null,
  classes: {},
  className: null,
};

export default withStyles(styles)(Info);
